import { render, staticRenderFns } from "./ClientesALecturar.vue?vue&type=template&id=96703bcc&"
import script from "@/Servicios/ClientesALecturar.js?vue&type=script&lang=js&"
export * from "@/Servicios/ClientesALecturar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports